import { jwtDecode } from "jwt-decode"

/** localStorage: tokens dos pedidos feitos neste aparelho (link e "Ver ingressos"). */
export const ORDER_TOKENS_KEY = "orderTokens"
const MAX_REMEMBERED = 10

type TOrderClaims = { scope?: string; event_id?: string; order_id?: string }
type TSavedToken = { orderId: string; token: string }

/** Evento e pedido do token do pedido (scope "order"); null para qualquer outro. */
export const readOrderToken = (
  token?: string | null,
): { eventId: string; orderId: string } | null => {
  if (!token) return null
  try {
    const claims = jwtDecode<TOrderClaims>(token)
    if (claims.scope !== "order" || !claims.event_id || !claims.order_id) return null
    return { eventId: String(claims.event_id), orderId: String(claims.order_id) }
  } catch {
    return null
  }
}

const readSaved = (): TSavedToken[] => {
  try {
    const list = JSON.parse(localStorage.getItem(ORDER_TOKENS_KEY) ?? "[]")
    if (!Array.isArray(list)) return []
    return list.filter(
      (i) => i && typeof i.orderId === "string" && typeof i.token === "string",
    )
  } catch {
    return []
  }
}

/**
 * Depois do sign: lembra o token do pedido (link "guardar no WhatsApp" e
 * "Ver ingressos") e, sem login de conta, usa ele como sessão do
 * pós-pagamento (getPurchase, envio e status do ingresso). Token de conta
 * não é trocado: quem comprou logado continua com "Meus ingressos".
 *
 * `asSession`: o comprador desta aba não tem conta (sem `sessionStorage.user`
 * ou visitante). O token do pedido vira a sessão mesmo que outra aba tenha
 * deixado um token de conta no localStorage (compartilhado entre abas) — com
 * ele o pós-pagamento de um telefone diferente daria 404. A outra aba vai
 * pedir o login de novo.
 */
export const adoptOrderToken = (
  orderId: string,
  orderToken?: string,
  options?: { asSession?: boolean },
) => {
  if (!orderId || !orderToken || !readOrderToken(orderToken)) return
  try {
    const current = localStorage.getItem("token")
    if (
      options?.asSession ||
      !current ||
      current === "undefined" ||
      readOrderToken(current)
    ) {
      localStorage.setItem("token", orderToken)
    }

    const next = [
      { orderId, token: orderToken },
      ...readSaved().filter((s) => s.orderId !== orderId),
    ].slice(0, MAX_REMEMBERED)
    localStorage.setItem(ORDER_TOKENS_KEY, JSON.stringify(next))
  } catch {}
}

/** Token do pedido feito neste aparelho ("" quando não tem). */
export const orderTokenFor = (orderId: string): string =>
  readSaved().find((s) => s.orderId === orderId)?.token ?? ""

/** Logout: esquece os tokens de pedido deste aparelho. */
export const clearOrderTokens = () => {
  try {
    localStorage.removeItem(ORDER_TOKENS_KEY)
  } catch {}
}
